module.exports = require('./helpers/bundle-url').getBundleURL('jPd2H') + "battery-charging.ba1b1745.webp";